import styled, { keyframes } from 'styled-components';
import { NotesSavedCheckmark } from 'components/VehicleCommon/icons/NotesSavedChekmark';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const LoaderIcon = styled.div`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: #e0e0e0;
  border-right-color: #616161;
  animation: ${rotate} 1s linear infinite;
`;

type Props = {
  status: string;
  showInitialCheckmark?: boolean;
};

const StatusWrapper = styled('div')`
  position: absolute;
  right: -20px;
`;

const IndicatorWrapper = styled('div')`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`;

export const NotesStatusIcon = ({ status, showInitialCheckmark = false }: Props) => {
  if (status === 'uninitialized') {
    if (showInitialCheckmark) {
      return (
        <IndicatorWrapper>
          <StatusWrapper>
            <NotesSavedCheckmark primary="#3994DE" />
          </StatusWrapper>
        </IndicatorWrapper>
      );
    }

    return null;
  }

  return (
    <IndicatorWrapper>
      <StatusWrapper>
        {status === 'pending' && <LoaderIcon />}
        {status === 'fulfilled' && <NotesSavedCheckmark primary="#3994DE" />}
      </StatusWrapper>
    </IndicatorWrapper>
  );
};
